export default "__VITE_ASSET__9d46a072__"